import React from 'react';
import { useDispatch } from 'react-redux';
import { persistInvoice } from 'src/store/actions/invoice-actions';
import { toast } from 'react-toastify';
import { IInvoice } from 'src/types/invoice';
import { DropdownList } from 'react-widgets';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import GeneralEnum from '../../../../../../../../../enumerables/general-enum';
import user from '../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';

interface Props {
    data: IInvoice;
}

const StatusProviderAction: React.FunctionComponent<Props> = ({ data: { id, status } }: Props) => {
    const dispatch = useDispatch();

    const onChangeDrop = (st: number) => {
        dispatch(
            persistInvoice({ id, status: st }, [], {
                resolve: () => {
                    toast.success('status successfully updated!');
                },
                reject: (errorMessage: string) => {
                    toast.error(errorMessage);
                },
            }),
        );
    };

    const statusEnum = GeneralEnum ? GeneralEnum.getEnum('InvoiceStatus') : {};
    const statuses: SelectObject[] = getValFromEnum(statusEnum);
    let valStatus = { label: 'All', value: '1' };

    const selectValuesStatus: SelectObject[] = [];
    statuses.forEach((it) => {
        if (+it.value === 6) {
            selectValuesStatus.push(it);
        }
        if (+it.value === +status) {
            valStatus = it;
        }
    });

    return (
        <>
            <div>
                {user.getRoles().includes(UserRole.ROLE_ADMIN) && (+status === 5 || +status === 4) ? (
                    <DropdownList
                        data={selectValuesStatus}
                        containerClassName={'w-100'}
                        textField="label"
                        valueField="value"
                        onChange={(item: SelectObject) => {
                            onChangeDrop(item.value);
                        }}
                        value={valStatus}
                    />
                ) : (
                    valStatus.label
                )}
            </div>
        </>
    );
};

export default StatusProviderAction;
